<button mat-raised-button *ngFor="let button of buttons" (click)="clickButton(button.action)">{{button.label}}</button>
